import * as vp from 'vopay';
import { FunctionComponent, JSX, useContext } from 'react';

import AccountCreationContext from './AccountCreationContext';

const { Box, Icon, SubTitle, Table } = vp;

export type SectionProps = {
  sectionId: string;
  showSubLabels?: boolean;
};

type FC = FunctionComponent<SectionProps>;

const MultiStepSection: FC = ({ sectionId, showSubLabels = false }: SectionProps) => {
  const ctx = useContext(AccountCreationContext);
  const { getErrorElementsBySection, isRequiredField, getSection } = ctx.useFields();

  return (
    <Box mb="lg" flx="col">
      {getErrorElementsBySection(sectionId, ctx)}
      {getSection(sectionId)
        .filter((subSection) => subSection.showSection(ctx))
        .map(({ label, fields }) => {
          return (
            <Box key={`${sectionId}-${label}`} mb="lg" flx="col">
              {showSubLabels && <SubTitle subTitle={label} />}
              <Table
                {...{
                  name: `new-contact-creation-${sectionId}`,
                  variant: 'pair',
                  columns: {
                    key: { header: 'Key' },
                    input: { header: 'Input' },
                  },
                  rows: (Object.keys(fields) as (keyof typeof fields)[])
                    .filter((fieldName) => runFilter(fieldName))
                    .map((fieldName) => ({
                      key: (
                        <Box ai="center">
                          {fields ? fields[fieldName]?.label : ''}
                          {getRequiredIcon(fieldName)}
                        </Box>
                      ),
                      input: getElement(fieldName),
                    })),
                }}
              />
            </Box>
          );

          function runFilter(fieldName: keyof typeof fields): boolean {
            return Boolean(fields[fieldName]?.showField(ctx));
          }

          function getElement(fieldName: keyof typeof fields): JSX.Element | string {
            return fields[fieldName]?.getElement(ctx) || '';
          }

          function getRequiredIcon(fieldName: keyof typeof fields): JSX.Element {
            return isRequiredField(sectionId, fieldName, ctx) ? (
              <Icon icon="asterisk" size="xsm" color="error" />
            ) : (
              <></>
            );
          }
        })}
    </Box>
  );
};

export default MultiStepSection;
